import React, { Component, ReactElement } from 'react'
import { UserInfoContextProvider, LanguageContextProvider } from '../../React/Common/Contexts'
import { Router as RouterLang } from '../../../i18n'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { PageTitle } from '../Components/Molecules/PageTitle/PageTitle'

@Route(RouteID.CRM_INTEGRATION)
export class CrmIntegration extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CRM_INTEGRATION}>
                <UserInfoContextProvider>
                    <LanguageContextProvider>
                        <PageTitle title={RouterLang.PageTitle_crmIntegration}></PageTitle>
                    </LanguageContextProvider>
                </UserInfoContextProvider>
            </RouteGuard>
        )
    }
}
